var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_attention_svg__a",
    d: "M0 32h32V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.82 25.937L17.25 3.72a1.446 1.446 0 00-2.5 0L2.18 25.937A1.393 1.393 0 003.429 28h25.142c.497.01.963-.245 1.221-.67.257-.426.268-.957.028-1.393",
    fill: "#BF0000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "icon_attention_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_attention_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#icon_attention_svg__b)",
    d: "M14.5 19h3v-9h-3zM14 23A2 2 0 1118 23 2 2 0 0114 23"
  }))));
}

export default SvgIconAttention;